import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "12 16 16 12 12 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "16", y1: "12", y2: "12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowRightCircle";
const ArrowRightCircle = memo(themed(Icon));
export {
  ArrowRightCircle
};
//# sourceMappingURL=arrow-right-circle.js.map
